<template>
  <modal
    transition="nice-modal-fade"
    width="760"
    :adaptive="true"
    :reset="true"
    height="auto"
    :name="modalName"
    class="listing--form-modal action--modal ank--progress-modal"
    :scrollable="true"
    @before-open="beforeOpen"
  >
    <div class="modal--wrapper">
      <section-loading :show="loading" />
      <button type="button" class="close" @click="close">
        <img src="@/assets/img/icons/close-1.svg" />
      </button>
      <section class="modal--container">
        <div class="ank--title">Pantau Progress Badge Agen Naik Kelas Anda</div>

        <div class="ank--step-list">
          <div class="ank--step-item" v-for="(step, index) in steps" :key="step.key">
            <button type="button" class="ank--step-header" @click="toggleStep(step.key)">
              <div class="ank--step-left">
                <div class="ank--step-index" :class="statusClass(step.status)">
                  <template v-if="step.status === 'done'">
                    <v-icon small>mdi-check</v-icon>
                  </template>
                  <template v-else>{{ index + 1 }}</template>
                </div>
                <div class="ank--step-title">{{ step.title }}</div>
              </div>
              <v-icon class="ank--step-chevron">
                {{ expandedSteps.includes(step.key) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
              </v-icon>
            </button>

            <div class="ank--step-body" v-if="expandedSteps.includes(step.key)">
              <div
                v-if="step.key === 'membership' && step.status === 'done'"
                class="ank--step-message ank--membership-message"
              >
                <div class="ank--membership-success">Anda sudah memenuhi kriteria ini</div>
                <div class="ank--membership-detail">
                  Membership anda saat ini adalah <b>{{ membershipDisplayLabel }}</b
                  ><template v-if="membershipExpiredAtLabel">
                    . Masa Berakhir Membership Anda {{ membershipExpiredAtLabel }}.</template
                  >
                </div>
              </div>
              <div
                v-else
                class="ank--step-message"
                :class="{
                  'is-success': step.status === 'done',
                  'is-alert': step.key === 'certificate' && !hasCertificate,
                }"
              >
                {{ step.message }}
              </div>

              <div v-if="step.key === 'certificate'">
                <div class="ank--upload-box">
                  <div class="ank--upload-row" v-if="hasUploadedCertificateFile">
                    <div class="ank--uploaded-label">File Terunggah</div>
                    <div class="ank--uploaded-chip">
                      <div class="ank--upload-file">
                        <v-icon>mdi-file-document</v-icon>
                        <span>{{ selectedFileName || visibleCertificateFileName }}</span>
                      </div>
                      <button
                        type="button"
                        class="ank--delete-file"
                        :disabled="savingCertificate || ankUploading"
                        @click="removeCertificateFile"
                      >
                        <v-icon small>mdi-delete-outline</v-icon>
                      </button>
                    </div>
                    <div
                      v-if="savingCertificate"
                      class="ank--certificate-saving"
                      role="status"
                      aria-live="polite"
                    >
                      <v-progress-circular indeterminate :size="20" :width="2" color="primary" />
                      <span>Menyimpan sertifikat...</span>
                    </div>
                  </div>
                  <div
                    v-else
                    class="ank--upload-empty"
                    @dragover.prevent
                    @dragenter.prevent
                    @drop.prevent="onFileDrop"
                  >
                    <div class="ank--upload-empty-icon">
                      <v-icon>mdi-cloud-upload-outline</v-icon>
                    </div>
                    <div class="ank--upload-empty-main">
                      Seret file ke sini atau
                      <span class="ank--browse" @click="pickFile">Pilih File</span>
                    </div>
                    <div class="ank--upload-note">
                      Unggah file sertifikat untuk diverifikasi oleh admin. Nomor sertifikat dan
                      logo LSP akan ditampilkan setelah verifikasi disetujui.
                    </div>
                    <div class="ank--upload-note">Format yang didukung: PDF, PNG, JPG, JPEG</div>
                  </div>
                  <input
                    ref="certificateInput"
                    type="file"
                    accept=".pdf,.png,.jpg,.jpeg,image/png,image/jpeg,application/pdf"
                    style="display: none"
                    @change="onFileChange"
                  />
                  <button
                    v-if="!hasUploadedCertificateFile"
                    type="button"
                    class="btn btn-primary ank--upload-btn"
                    @click="pickFile"
                    :disabled="ankUploading"
                  >
                    {{ ankUploading ? 'Mengunggah...' : 'Unggah File' }}
                  </button>
                </div>
              </div>

              <div v-if="step.key === 'review'" class="ank--review-timeline">
                <div
                  class="ank--review-item"
                  v-for="(item, idx) in reviewHistoryPreview"
                  :key="`ank-review-preview-${item.reviewId || idx}`"
                >
                  <div class="ank--review-head">
                    <div class="ank--review-status" :class="`is-${item.type}`">
                      {{ item.typeLabel }}
                    </div>
                    <div class="ank--review-date">
                      <v-icon small>mdi-clock-time-four-outline</v-icon>
                      <span>{{ formatShortDate(item.date) }}</span>
                    </div>
                  </div>
                  <div class="ank--review-message" :class="`is-${item.type}`">
                    {{ item.message }}
                  </div>
                </div>
                <div class="ank--history-btn-wrap">
                  <button type="button" class="btn btn-outline-primary" @click="openAllHistory">
                    Lihat Semua Riwayat
                  </button>
                </div>
              </div>

              <button
                v-if="step.actionLabel"
                type="button"
                class="btn btn-primary ank--cta-btn"
                @click="handleStepAction(step.action)"
              >
                {{ step.actionLabel }}
              </button>
            </div>
          </div>
        </div>

        <div class="ank--learn-more">
          Pelajari Selengkapnya
          <button type="button" class="ank--link-btn" @click="goToLearnMore">Disini</button>
        </div>
      </section>
    </div>
  </modal>
</template>

<script>
import { mapState } from 'vuex';
const SectionLoading = () => import('@/components/content-loading/section-loading');

export default {
  name: 'agen-naik-kelas-progress-modal',
  components: {
    SectionLoading,
  },
  data() {
    return {
      modalName: 'agen-naik-kelas-progress-modal',
      loading: false,
      steps: [],
      expandedSteps: [],
      selectedFileContentUuid: null,
      selectedFileName: null,
      removedExistingCertificate: false,
      savingCertificate: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.global.user,
      ankUploading: (state) => state.agenNaikKelas.uploading,
      reviewStatus: (state) => state.agenNaikKelas.reviewStatus,
      checklist: (state) => state.agenNaikKelas.checklist,
      percentageSuccess: (state) => state.agenNaikKelas.percentageSuccess,
      certificateFileName: (state) => state.agenNaikKelas.certificateFileName,
      certificateFileContentUuid: (state) => state.agenNaikKelas.certificateFileContentUuid,
      historyEvents: (state) => state.agenNaikKelas.history,
    }),
    membershipType() {
      if (!this.user || !this.user.membership || !this.user.membership.type) return null;
      const type = `${this.user.membership.type}`.toUpperCase();
      if (type === 'PLATINUM') return 'EXECUTIVE';
      if (type === 'GOLD') return 'PRO';
      if (type === 'SILVER') return 'STARTER';
      return type;
    },
    hasQualifiedMembership() {
      return !!(this.checklist && this.checklist.membership);
    },
    hasCompleteProfile() {
      return !!(this.checklist && this.checklist.profile_completion);
    },
    hasProfilePhoto() {
      return !!(this.checklist && this.checklist.photo_profile);
    },
    hasBiography() {
      return !!(this.checklist && this.checklist.biography);
    },
    hasCertificate() {
      return !!(this.checklist && this.checklist.certificate);
    },
    normalizedReviewStatus() {
      return this.reviewStatus ? `${this.reviewStatus}`.toUpperCase() : 'NOT_REVIEWED';
    },
    progressPercent() {
      const value = Number(this.percentageSuccess || 0);
      if (value < 0) return 0;
      if (value > 100) return 100;
      return value;
    },
    membershipDisplayLabel() {
      if (this.membershipType === 'PRO') return 'Membership Pro';
      if (this.membershipType === 'EXECUTIVE') return 'Membership Executive';
      if (this.membershipType === 'STARTER') return 'Membership Starter';
      return this.membershipType ? `Membership ${this.membershipType}` : 'Membership';
    },
    membershipExpiredAtLabel() {
      const raw = this.user && this.user.membership ? this.user.membership.expired_at : null;
      if (!raw) return null;
      const date = new Date(raw);
      if (Number.isNaN(date.getTime())) return null;

      const day = `${date.getDate()}`.padStart(2, '0');
      const month = `${date.getMonth() + 1}`.padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
    reviewHistoryPreview() {
      if (!Array.isArray(this.historyEvents)) return [];
      return this.historyEvents.slice(0, 2);
    },
    visibleCertificateFileName() {
      return this.removedExistingCertificate ? null : this.certificateFileName;
    },
    hasUploadedCertificateFile() {
      return !!(this.selectedFileName || this.visibleCertificateFileName);
    },
    hasValidCertificateFile() {
      return !!(
        this.selectedFileContentUuid ||
        (!this.removedExistingCertificate && this.certificateFileContentUuid)
      );
    },
    canSaveCertificateData() {
      return !this.ankUploading && this.hasValidCertificateFile;
    },
  },
  methods: {
    async beforeOpen() {
      this.loading = true;
      try {
        await this.$store.dispatch('agenNaikKelas/getTimelineProgress');
        await this.$store.dispatch('agenNaikKelas/getStatusHistory');
        this.selectedFileContentUuid = null;
        this.selectedFileName = null;
        this.removedExistingCertificate = false;
        this.buildSteps();
        this.expandDefaultStep();
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.$modal.hide(this.modalName);
    },
    toggleStep(key) {
      if (this.expandedSteps.includes(key)) {
        this.expandedSteps = this.expandedSteps.filter((item) => item !== key);
      } else {
        this.expandedSteps.push(key);
      }
    },
    statusClass(status) {
      if (status === 'done') return 'is-done';
      if (status === 'active') return 'is-active';
      if (status === 'danger') return 'is-danger';
      return 'is-pending';
    },
    buildSteps() {
      const membershipMessage = this.hasQualifiedMembership
        ? this.membershipType
          ? `Anda sudah memenuhi kriteria ini. Membership Anda saat ini adalah ${this.membershipType}.`
          : 'Anda sudah memenuhi kriteria ini.'
        : 'Anda belum memiliki membership Pro atau Executive.';

      const profileMessage = this.hasCompleteProfile
        ? 'Kerja bagus. Profil Anda sudah lengkap.'
        : 'Profil Anda belum lengkap. Silakan lengkapi data utama profil Anda.';

      const photoMessage = this.hasProfilePhoto
        ? 'Kerja bagus. Anda sudah melakukan upload foto profil.'
        : 'Anda belum melakukan upload foto profil.';

      const bioMessage = this.hasBiography
        ? 'Kerja bagus. Biografi Anda sudah terisi.'
        : 'Oops. Biografi Anda belum terisi.';

      const certificateMessage = this.hasCertificate
        ? 'Anda sudah mengunggah Sertifikat Kompetensi Profesi Broker Properti Indonesia.'
        : 'Anda belum mengunggah Sertifikat Kompetensi Profesi Broker Properti Indonesia.';

      let reviewMessage = 'Selesaikan langkah sebelumnya untuk masuk ke tahap review admin.';
      if (this.hasCertificate) {
        if (this.normalizedReviewStatus === 'APPROVED') {
          reviewMessage = 'Status badge Agen Naik Kelas Anda berhasil diaktifkan.';
        } else if (this.normalizedReviewStatus === 'REJECTED') {
          reviewMessage =
            'Status badge Agen Naik Kelas Anda ditolak. Silakan lihat riwayat dan perbaiki data yang diperlukan.';
        } else {
          reviewMessage =
            'Status badge Agen Naik Kelas Anda sedang direview oleh admin. Mohon menunggu.';
        }
      }

      this.steps = [
        {
          key: 'membership',
          title: 'Memiliki Membership Pro atau Executive Aktif',
          status: this.hasQualifiedMembership ? 'done' : 'active',
          message: membershipMessage,
          action: this.hasQualifiedMembership ? null : 'upgrade',
          actionLabel: this.hasQualifiedMembership ? null : 'Upgrade Membership Sekarang',
        },
        {
          key: 'profile',
          title: 'Lengkapi Profil',
          status: this.hasCompleteProfile ? 'done' : 'active',
          message: profileMessage,
          action: this.hasCompleteProfile ? null : 'profile',
          actionLabel: this.hasCompleteProfile ? null : 'Lengkapi Profil',
        },
        {
          key: 'photo',
          title: 'Upload Foto Profil Professional',
          status: this.hasProfilePhoto ? 'done' : 'active',
          message: photoMessage,
          action: this.hasProfilePhoto ? null : 'profile',
          actionLabel: this.hasProfilePhoto ? null : 'Upload Foto Profil Sekarang',
        },
        {
          key: 'biography',
          title: 'Lengkapi Biografi',
          status: this.hasBiography ? 'done' : 'active',
          message: bioMessage,
          action: this.hasBiography ? null : 'profile',
          actionLabel: this.hasBiography ? null : 'Isi Biografi Sekarang',
        },
        {
          key: 'certificate',
          title: 'Unggah Sertifikat Kompetensi Profesi Broker Properti Indonesia',
          status: this.hasCertificate ? 'done' : 'active',
          message: certificateMessage,
          action: null,
          actionLabel: null,
        },
        {
          key: 'review',
          title: 'Review Oleh Admin',
          status:
            this.normalizedReviewStatus === 'APPROVED'
              ? 'done'
              : this.normalizedReviewStatus === 'REJECTED'
              ? 'danger'
              : 'active',
          message: reviewMessage,
          action: null,
          actionLabel: null,
        },
      ];
    },
    expandDefaultStep() {
      const firstNotDone = this.steps.find((step) => step.status !== 'done');
      this.expandedSteps = [firstNotDone ? firstNotDone.key : 'review'];
    },
    handleStepAction(action) {
      if (action === 'upgrade') {
        this.close();
        this.$router.push({ name: 'upgrade' });
      } else if (action === 'profile') {
        this.close();
        this.$router.push('/profile');
      }
    },
    goToLearnMore() {
      this.close();
      this.$router.push('/layanan-agen/agen-naik-kelas');
    },
    getCertificateInputRef() {
      const inputRef = this.$refs.certificateInput;
      if (Array.isArray(inputRef)) {
        return inputRef[0] || null;
      }
      return inputRef || null;
    },
    pickFile() {
      const input = this.getCertificateInputRef();
      if (input && typeof input.click === 'function') {
        input.click();
      }
    },
    removeCertificateFile() {
      this.selectedFileContentUuid = null;
      this.selectedFileName = null;
      this.removedExistingCertificate = true;
      const input = this.getCertificateInputRef();
      if (input) {
        input.value = null;
      }
    },
    onFileChange(event) {
      const files = event.target.files || [];
      const file = files[0];
      if (!file) return;
      this.processSelectedFile(file);
    },
    onFileDrop(event) {
      const files = event.dataTransfer && event.dataTransfer.files ? event.dataTransfer.files : [];
      const file = files[0];
      if (!file) return;
      this.processSelectedFile(file);
    },
    async processSelectedFile(file) {
      if (!file) return;

      const allowedMimeTypes = ['application/pdf', 'image/png', 'image/jpeg'];
      const fileName = (file.name || '').toLowerCase();
      const validByExtension =
        fileName.endsWith('.pdf') ||
        fileName.endsWith('.png') ||
        fileName.endsWith('.jpg') ||
        fileName.endsWith('.jpeg');
      const validByMime = allowedMimeTypes.includes(file.type);

      if (!validByMime && !validByExtension) {
        this.$swal(
          'Format Tidak Didukung',
          'File harus berformat PDF, PNG, JPG, atau JPEG.',
          'warning',
        );
        return;
      }

      try {
        const result = await this.$store.dispatch(
          'agenNaikKelas/uploadCertificateFileContent',
          file,
        );
        this.selectedFileContentUuid = result ? result.file_content_uuid || null : null;
        this.selectedFileName = file.name || '';
        const input = this.getCertificateInputRef();
        if (input) {
          input.value = null;
        }
        await this.saveCertificateData();
      } catch (e) {
        this.$swal(
          'Gagal Upload',
          'Terjadi kendala saat mengupload file. Silakan coba lagi.',
          'error',
        );
      }
    },
    async saveCertificateData() {
      const fileContentUuid =
        this.selectedFileContentUuid ||
        (this.removedExistingCertificate ? null : this.certificateFileContentUuid);
      if (!fileContentUuid) {
        this.$swal(
          'Data Belum Lengkap',
          'Silakan upload file sertifikat terlebih dahulu.',
          'warning',
        );
        return;
      }
      this.savingCertificate = true;
      try {
        await this.$store.dispatch('agenNaikKelas/saveCertificate', {
          file_content_uuid: fileContentUuid,
        });
        this.savingCertificate = false;
        this.$swal('Berhasil', 'Data sertifikat berhasil disimpan.', 'success');
        this.removedExistingCertificate = false;
        await new Promise((resolve) => setTimeout(resolve, 10000));
        await this.$store.dispatch('agenNaikKelas/getTimelineProgress');
        await this.$store.dispatch('agenNaikKelas/getStatusHistory');
        this.buildSteps();
      } catch (e) {
        this.$swal(
          'Gagal Menyimpan',
          'Terjadi kendala saat menyimpan data sertifikat. Silakan coba lagi.',
          'error',
        );
      } finally {
        this.savingCertificate = false;
      }
    },
    openAllHistory() {
      this.$modal.show('agen-naik-kelas-history-modal');
    },
    formatShortDate(value) {
      if (!value) return '-';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return '-';
      const day = `${date.getDate()}`.padStart(2, '0');
      const month = `${date.getMonth() + 1}`.padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
  },
};
</script>

<style
  lang="scss"
  scoped
  src="@/assets/scss/components/agen-naik-kelas-progress-modal.scss"
></style>
